import React from "react";
import { HiOutlineOfficeBuilding } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneHotel } from "../../../lib/sysNavigation/SysNavigation";

type HotelRow = {
  hotel_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<HotelRow>
    type={_TYPES_.HOTEL}
    title="Hotels"
    subtitle="Hospitality venues promoted on the public site."
    icon={<HiOutlineOfficeBuilding className="h-5 w-5" />}
    addRoute="/data/hotel/add"
    editRoute="/data/hotel/edit"
    pushOne={pushOneHotel}
    dataKey="hotels"
    countKey="hotelsCount"
    idField="hotel_id"
    titleField="title"
  />
);

export default Overview;
